import React, { useCallback, useMemo } from 'react'

import { LightSelect, Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, shape, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

function ReasonSelect({
  selectedReason = null,
  isOtherSelected = false,
  otherText = '',
  onReasonChange,
  onOtherTextChange,
  maxCustomReasonLength,
  locale = 'en',
}) {
  const translate = useCallback(
    (key) => I18n.t(
      `subscription_management.cancel_modal.${key}`,
      { ns: 'rails', lng: locale }
    ),
    [locale]
  )

  const reasonOptions = useMemo(() => [
    { value: 'no_longer_need', label: translate('reasons.no_longer_need') },
    { value: 'short_term_project', label: translate('reasons.short_term_project') },
    { value: 'not_enough_models', label: translate('reasons.not_enough_models') },
    { value: 'not_worth_price', label: translate('reasons.not_worth_price') },
    { value: 'not_used_enough', label: translate('reasons.not_used_enough') },
    { value: 'prefer_individual', label: translate('reasons.prefer_individual') },
    { value: 'other', label: translate('reasons.other') },
  ], [translate])

  return (
    <>
      <div className="cancel-subscription-modal__reason">
        <label
          className="cgt-text-medium cgt-text-medium--semi-bold"
          htmlFor="cancel-reason"
        >
          {translate('reason_label')}
        </label>
        <LightSelect
          id="cancel-reason"
          name="cancel-reason"
          options={reasonOptions}
          value={selectedReason ? selectedReason.value : ''}
          onChange={onReasonChange}
          placeholder={translate('reason_placeholder')}
          isFullWidth
        />
      </div>
      {isOtherSelected && (
        <div className="cancel-subscription-modal__reason">
          <label
            className="cgt-text-medium cgt-text-medium--semi-bold"
            htmlFor="cancel-other-reason"
          >
            {translate('other_label')}
          </label>
          <Textarea
            id="cancel-other-reason"
            placeholder={translate('other_placeholder')}
            value={otherText}
            onChange={onOtherTextChange}
            maxLength={maxCustomReasonLength}
            rows={3}
            isNotResizable
          />
        </div>
      )}
    </>
  )
}

ReasonSelect.propTypes = {
  selectedReason: shape({
    value: string,
    label: string,
  }),
  isOtherSelected: bool,
  otherText: string,
  onReasonChange: func.isRequired,
  onOtherTextChange: func.isRequired,
  maxCustomReasonLength: number.isRequired,
  locale: string,
}

export default ReasonSelect
